import CityPageTemplate from "../city-template/CityPageTemplate";
import { burkeVaConfig } from "./data";

export default function BurkeVaPage() {
  return <CityPageTemplate config={burkeVaConfig} />;
}